import { render, staticRenderFns } from "./gzf.vue?vue&type=template&id=14a2f7a7&scoped=true"
import script from "./gzf.vue?vue&type=script&lang=js"
export * from "./gzf.vue?vue&type=script&lang=js"
import style0 from "./gzf.vue?vue&type=style&index=0&id=14a2f7a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a2f7a7",
  null
  
)

export default component.exports